import { PFH_DICTIONARY } from './pfh'
import { PWC_DICTIONARY } from './pwc'

export const DICTIONARY = {
  standard: {
    housing: 'Housing',
    consultant: 'Consultant',
    consultants: 'Consultants',
    corporate: 'Corporate',
    corporates: 'Corporates',
    selectCorporate: 'Select Corporate',
    transfereeNameOrReference: 'Transferee Name or Reference',
    fileNumberOrReference: 'File Number or Reference',
    fileNumberEmployeeIdOrReference: 'File Number, Employee ID or Reference',
    location: 'Location',
    price: 'Price',
    guest: 'Guest',
    officeAddressOrPreferredLocation: 'Office Address or Preferred Location',
    enterYourLocationOfPreference: 'Enter your Location of Preference',
    reference: 'Reference',
    refNumber: 'Ref. number',
    hrBookings: 'HR Bookings',
    companiesManagement: 'Companies Management',
    corporateFilter: 'Corporate',
    corporateFilterPlaceholder: 'Find corporate',
    altoinsightCorporateFilter: 'Corporate / Business Line',
    altoinsightCorporateFilterPlaceholder: 'Find Corporate / Business Line',
    topCorporates: 'Top Corporates / Business Lines',
    email: 'Email',
    topConsultants: 'Top Consultants',
    employee: 'Employee',
    employees: 'Employees',
  },
  pwc: PWC_DICTIONARY,
  pfh: PFH_DICTIONARY,
} as const
